import Image from 'next/image';

export default function CompanyNameColorLogo() {
  return (
    <div className="flex flex-col items-center space-y-2 w-full">
      <div className="relative w-full h-16 sm:h-20 lg:h-24">
        <Image
          src="/logos/CAREASCENDIUM_Logo_color.png"
          alt="Company Logo"
          layout="fill"
          objectFit="contain"
        />
      </div>
      <div className="relative w-full h-16 sm:h-20 lg:h-24">
        <Image
          src="/logos/CAREASCENDIUM_name_color.png"
          alt="Company Name"
          layout="fill"
          objectFit="contain"
          style={{
            padding: '20px'
          }}
        />
      </div>
    </div>
  );
}